const config = {
    // backendUrl: "http://localhost:9000"
    backendUrl: "https://mindweb.bosik.app/api"
};

export default config;